export const mergeClasses = (
  classObjects: Array<Record<string, string> | undefined>
): Record<string, string> => {
  const filterClassObjects = classObjects.filter(
    (classObject) => typeof classObject === 'object'
  );

  return filterClassObjects?.reduce(
    (accumulatedClasses, currentClass) => {
      Object.entries(currentClass).forEach(([key, value]) => {
        if (accumulatedClasses[key]) {
          accumulatedClasses[key] += ` ${value}`;
        } else {
          accumulatedClasses[key] = value;
        }
      });
      return accumulatedClasses;
    },
    {} as Record<string, string>
  );
};
